import React from 'react'

// apollo
import { useQuery } from '@apollo/client'

// components
import LimitedAvailabilityModal from 'components/shared/Cart/Form/Camper/Session/PanelContents/Form/SelectLocation/LimitedAvailabilityModal'

// query
import query from './limitedAvailability.graphql'

// Wraps the cart's LimitedAvailabilityModal for contexts (account plans,
// account overview) where the session's full list of locations and their peak
// periods hasn't already been loaded. Fetches that data lazily when opened.
const LimitedAvailabilityModalContainer = props => {
  const { open, onClose, sessionId, registeredAt } = props

  const { data, loading } = useQuery(query, {
    variables: { sessionId },
    skip: !open || !sessionId
  })

  const session = data && data.sessions && data.sessions[0]
  const plan = registeredAt ? { registeredAt } : null

  return (
    <LimitedAvailabilityModal
      open={open}
      onClose={onClose}
      session={session}
      plan={plan}
      loading={loading}
    />
  )
}

export default LimitedAvailabilityModalContainer
